import React, { useState, useEffect } from "react";

const C = {
  bg:     "#000000",
  card:   "#111111",
  card2:  "#1C1C1E",
  text:   "#FFFFFF",
  muted:  "#8A8A8E",
  red:    "#FF0000",
  border: "#2A2A2A",
  green:  "#2D5A3D",
};

function BackBtn({ onBack, t = {} }) {
  return (
    <button
      onClick={onBack}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        background: "#EAF3DE", border: "1.5px solid #2D5A3D40",
        borderRadius: 10, padding: "8px 14px",
        color: "#2D5A3D", fontSize: 13, fontWeight: 800,
        cursor: "pointer", fontFamily: "inherit",
        marginBottom: 20,
      }}
    >
      {t.retour || "← Retour"}
    </button>
  );
}

function Step({ num, title, desc }) {
  return (
    <div style={{ display: "flex", gap: 14, marginBottom: 20 }}>
      <div style={{
        width: 32, height: 32, borderRadius: "50%",
        background: C.red, color: "white",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 14, fontWeight: 900, flexShrink: 0, marginTop: 2,
      }}>
        {num}
      </div>
      <div>
        <div style={{ fontSize: 15, fontWeight: 800, color: C.text, marginBottom: 5 }}>
          {title}
        </div>
        <div style={{ fontSize: 13, color: C.muted, lineHeight: 1.55 }}>
          {desc}
        </div>
      </div>
    </div>
  );
}

/* ── Page principale ─────────────────────────────────────────── */
function PageMain({ onClose, onNav, assuranceTel, t = {} }) {
  const ITEMS = [
    {
      id: "accident",
      emoji: "🚨",
      title: t.enCasAccident || "En cas d'accident",
      sub: t.procedureSecurite || "Procédure · Sécurité · Assistance",
    },
    {
      id: "constat",
      emoji: "📋",
      title: t.guideConstat || "Guide constat européen",
      sub: t.remplirConstat || "Remplir sans erreur étape par étape",
    },
    {
      id: "services",
      emoji: "📍",
      title: t.servicesProches || "Services proches",
      sub: t.garageStation || "Garage / Dépannage et Station service",
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>

      {/* Bandeau rouge */}
      <div style={{
        background: C.red, padding: "28px 20px 24px",
        textAlign: "center", position: "relative",
      }}>
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: 16, right: 16,
            background: "rgba(0,0,0,0.25)", border: "none",
            color: "white", fontSize: 18, cursor: "pointer",
            borderRadius: 8, width: 34, height: 34,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontFamily: "inherit",
          }}
        >
          ✕
        </button>
        <div style={{ fontSize: 44, marginBottom: 8 }}>🆘</div>
        <div style={{ fontSize: 20, fontWeight: 900, color: "white", letterSpacing: 1, marginBottom: 6 }}>
          {t.boutonSecours || "BOUTON DE SECOURS"}
        </div>
        <div style={{ fontSize: 14, color: "rgba(255,255,255,0.85)", fontWeight: 600 }}>
          {t.resteCalme || "Reste calme, on est là. 🤜"}
        </div>
      </div>

      {/* Boutons */}
      <div style={{ padding: "20px 16px 0", flex: 1, overflowY: "auto" }}>
        {ITEMS.map(item => (
          <button
            key={item.id}
            onClick={() => onNav(item.id)}
            style={{
              width: "100%", background: C.card,
              border: `1px solid ${C.border}`,
              borderRadius: 16, padding: "18px 16px",
              marginBottom: 12, cursor: "pointer",
              fontFamily: "inherit", textAlign: "left",
              display: "flex", alignItems: "center", gap: 16,
            }}
          >
            <span style={{ fontSize: 32, lineHeight: 1 }}>{item.emoji}</span>
            <div>
              <div style={{ fontSize: 16, fontWeight: 800, color: C.text, marginBottom: 4 }}>
                {item.title}
              </div>
              <div style={{ fontSize: 12, color: C.muted }}>
                {item.sub}
              </div>
            </div>
            <div style={{ marginLeft: "auto", color: C.muted, fontSize: 18 }}>›</div>
          </button>
        ))}

        {/* Numéros rapides */}
        <div style={{
          background: C.card, borderRadius: 16, padding: "16px",
          border: `1px solid ${C.border}`, marginTop: 4,
        }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: 1, marginBottom: 12 }}>
            {t.appelRapide || "APPEL RAPIDE"}
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {[
              { label: "SAMU",                          num: "15" },
              { label: t.pompiers || "Pompiers",        num: "18" },
              { label: t.police   || "Police",          num: "17" },
              { label: t.europe   || "Europe",          num: "112" },
            ].map(({ label, num }) => (
              <a
                key={num}
                href={`tel:${num}`}
                style={{
                  flex: "1 1 40%", textAlign: "center",
                  background: "#1A0000", border: `1px solid ${C.red}33`,
                  borderRadius: 10, padding: "10px 6px",
                  textDecoration: "none",
                }}
              >
                <div style={{ fontSize: 20, fontWeight: 900, color: C.red }}>{num}</div>
                <div style={{ fontSize: 10, color: C.muted, marginTop: 2 }}>{label}</div>
              </a>
            ))}
          </div>
          {assuranceTel && (
            <>
              <div style={{ height: 1, background: C.border, margin: "10px 0" }} />
              <a
                href={`tel:${assuranceTel}`}
                style={{
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                  background: "#001A0A", border: "1px solid #2D9E4A33",
                  borderRadius: 10, padding: "10px 14px",
                  textDecoration: "none",
                }}
              >
                <div style={{ fontSize: 13, fontWeight: 700, color: "#2D9E4A" }}>{t.assurance || "Assurance"}</div>
                <div style={{ fontSize: 14, fontWeight: 900, color: "#2D9E4A" }}>{assuranceTel}</div>
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ── Page accident ───────────────────────────────────────────── */
function PageAccident({ onBack, t = {} }) {
  const [left, setLeft] = useState(true);
  useEffect(() => {
    const timer = setInterval(() => setLeft(v => !v), 500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{ padding: "20px 16px 0", overflowY: "auto", height: "100%" }}>
      <BackBtn onBack={onBack} t={t} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <span style={{ fontSize: 18, opacity: left ? 1 : 0.2, transition: "opacity 0.15s" }}>🚨</span>
        <span style={{ fontSize: 18, fontWeight: 900, color: C.text }}>{t.enCasAccident || "En cas d'accident"}</span>
        <span style={{ fontSize: 18, opacity: left ? 0.2 : 1, transition: "opacity 0.15s" }}>🚨</span>
      </div>
      <div style={{ fontSize: 13, color: C.muted, marginBottom: 24 }}>
        {t.suivezEtapes || "Suivez ces étapes dans l'ordre"}
      </div>

      <Step num={1} title={t.securiserZone || "Sécuriser la zone"} desc={t.securiserZoneDesc || "Coupez le moteur. Mettez le gilet jaune AVANT de sortir du véhicule. Placez le triangle à 30 m minimum."} />
      <Step num={2} title={t.verifierBlesses || "Vérifier les blessés"} desc={t.verifierBlessesDesc || "Si blessé grave : appelez le 15 (SAMU) ou le 18 (pompiers). Ne déplacez pas les blessés."} />
      <Step num={3} title={t.appelerSecours || "Appeler les secours"} desc={t.appelerSecoursDesc || "Police/Gendarmerie : 17 · SAMU : 15 · Pompiers : 18 · Numéro européen : 112"} />
      <Step num={4} title={t.contacterAssurance || "Contacter l'assurance"} desc={t.contacterAssuranceDesc || "Déclarez le sinistre dans les 5 jours ouvrés. Remplissez le constat à l'amiable."} />
    </div>
  );
}

/* ── Page constat ────────────────────────────────────────────── */
function PageConstat({ onBack, t = {} }) {
  const steps = [
    { title: t.constatStep1title || "Date, heure et lieu",           desc: t.constatStep1desc || "Notez précisément la date, l'heure et l'adresse exacte de l'accident." },
    { title: t.constatStep2title || "Blessés ?",                     desc: t.constatStep2desc || "Indiquez s'il y a des blessés. Si oui, appelez le 15 immédiatement." },
    { title: t.constatStep3title || "Dommages matériels",            desc: t.constatStep3desc || "Décrivez les dégâts visibles sur chaque véhicule. Prenez des photos." },
    { title: t.constatStep4title || "Témoins",                       desc: t.constatStep4desc || "Relevez les noms et coordonnées de tous les témoins présents." },
    { title: t.constatStep5title || "Véhicule A & B",                desc: t.constatStep5desc || "Remplissez les informations de chaque véhicule : marque, modèle, immatriculation." },
    { title: t.constatStep6title || "Assurances",                    desc: t.constatStep6desc || "Notez les numéros de contrat et les coordonnées des assureurs des deux parties." },
    { title: t.constatStep7title || "Croquis de l'accident",         desc: t.constatStep7desc || "Dessinez un schéma clair de la position des véhicules au moment du choc." },
    { title: t.constatStep8title || "Signatures obligatoires",       desc: t.constatStep8desc || "Les deux conducteurs DOIVENT signer le constat. Sans signature, il n'a aucune valeur." },
    { title: t.constatStep9title || "Ne jamais reconnaître sa faute",desc: t.constatStep9desc || "Ne signez aucun document sans l'accord de votre assureur." },
  ];

  return (
    <div style={{ padding: "20px 16px 0", overflowY: "auto", height: "100%" }}>
      <BackBtn onBack={onBack} t={t} />

      <div style={{ fontSize: 18, fontWeight: 900, color: C.text, marginBottom: 6 }}>
        📋 {t.guideConstat || "Guide constat européen"}
      </div>
      <div style={{ fontSize: 13, color: C.muted, marginBottom: 24 }}>
        {t.huitEtapes || "8 étapes pour remplir sans erreur"}
      </div>

      {steps.map((s, i) => (
        <Step key={i} num={i + 1} title={s.title} desc={s.desc} />
      ))}
      <div style={{ height: 24 }} />
    </div>
  );
}

/* ── Page services proches ───────────────────────────────────── */
function PageServices({ onBack, t = {} }) {
  const ITEMS = [
    {
      emoji: "🔧",
      title: t.garageDepannage || "Garage / Dépannage",
      sub: t.mapsPres || "Google Maps s'ouvre près de toi",
      url: "https://www.google.com/maps/search/garage+dépannage/",
    },
    {
      emoji: "⛽",
      title: t.stationService || "Station service",
      sub: t.mapsPres || "Google Maps s'ouvre près de toi",
      url: "https://www.google.com/maps/search/station+service/",
    },
  ];

  return (
    <div style={{ padding: "20px 16px 0", overflowY: "auto", height: "100%" }}>
      <BackBtn onBack={onBack} t={t} />

      <div style={{ fontSize: 18, fontWeight: 900, color: C.text, marginBottom: 6 }}>
        📍 {t.servicesProches || "Services proches"}
      </div>
      <div style={{ fontSize: 13, color: C.muted, marginBottom: 24 }}>
        {t.ouvreMaps || "Ouvre Google Maps directement près de ta position"}
      </div>

      {ITEMS.map(item => (
        <a
          key={item.title}
          href={item.url}
          target="_blank"
          rel="noreferrer"
          style={{
            display: "flex", alignItems: "center", gap: 16,
            background: C.card, borderRadius: 16, padding: "20px 16px",
            marginBottom: 12, textDecoration: "none",
            border: `1px solid ${C.border}`,
          }}
        >
          <span style={{ fontSize: 36 }}>{item.emoji}</span>
          <div>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.text, marginBottom: 4 }}>
              {item.title}
            </div>
            <div style={{ fontSize: 12, color: C.muted }}>{item.sub}</div>
          </div>
          <div style={{ marginLeft: "auto", color: C.muted, fontSize: 18 }}>›</div>
        </a>
      ))}
    </div>
  );
}

/* ── Export principal ────────────────────────────────────────── */
export default function SecoursScreen({ onClose, dossiers, t = {} }) {
  const [page, setPage] = useState("main");
  const assuranceTel = dossiers?.assurance?.tel || null;
  const assuranceNom = dossiers?.assurance?.nom || "Mon assurance";

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 1000,
      background: C.bg, overflowY: "auto",
      fontFamily: "-apple-system, 'SF Pro Display', 'Segoe UI', sans-serif",
      maxWidth: 430, margin: "0 auto",
    }}>
      {page === "main"     && <PageMain     onClose={onClose} onNav={setPage} assuranceTel={assuranceTel} t={t} />}
      {page === "accident" && <PageAccident onBack={() => setPage("main")} assuranceTel={assuranceTel} assuranceNom={assuranceNom} t={t} />}
      {page === "constat"  && <PageConstat  onBack={() => setPage("main")} t={t} />}
      {page === "services" && <PageServices onBack={() => setPage("main")} t={t} />}
    </div>
  );
}
